<template>
    <li
        class="d-sidebar-version-info"
    >
        <a
            class="nav-link c-sidebar-nav-link"
            :href="pipelineUri"
        >
            <b>oneCRM</b><br>
            <span v-if="nitroVersion.pipelineId">
                <span>Build-No.: #{{ nitroVersion.pipelineId }}</span><br>
                <span>Build-Date: {{ buildDate }}</span><br>
            </span>
            <span v-if="nitroVersion.tag">
                <span>Version: {{ nitroVersion.tag }}</span><br>
            </span>
            <span v-else-if="nitroVersion.branch">
                <span>Branch: {{ nitroVersion.branch }}</span><br>
            </span>
            <span v-if="environment === 'local'">Development Environment</span>
            <span v-else-if="environment === 'staging' || environment === 'stage'">Staging Environment</span>
            <span v-else>Production Environment</span>
        </a>
    </li>
</template>
<script>
export default {
    name: 'DSidebarVersionInfo',
    computed: {
        nitroVersion () {
            return this.$page?.props?.nitroVersion ?? {
                date: null,
                pipelineId: null
            }
        },
        environment () {
            return this.$page?.props?.environment
        },
        buildDate () {
            return new Date(this.nitroVersion.date).toLocaleString('de')
        },
        pipelineUri () {
            return this.nitroVersion.pipelineId
                ? 'https://git.dogado.net/crm/onecrm/-/pipelines/' + this.nitroVersion.pipelineId
                : '#'
        }
    }
}
</script>

<style scoped lang="scss">
.c-sidebar-unfoldable{
    .d-sidebar-version-info {
        display: none;
    }
    &:hover{
        .d-sidebar-version-info{
            display: block;
        }
    }
}
.d-sidebar-version-info {
    font-size: 12px;
    color: var(--dark);
    margin-top: auto;

    .c-sidebar-nav-link{
        white-space: unset;
        display: block;
        *{
            white-space: nowrap;
        }
    }

}
</style>
